// extracted by mini-css-extract-plugin
export var avatarContainer = "_ga-0";
export var avatarTypingWave = "_ga-i";
export var gray = "_ga-f";
export var green = "_ga-c";
export var icon = "_ga-9";
export var image = "_ga-1";
export var lg = "_ga-6";
export var md = "_ga-5";
export var presenceDot = "_ga-b";
export var red = "_ga-d";
export var sm = "_ga-4";
export var status = "_ga-a";
export var typingDot = "_ga-h";
export var typingPill = "_ga-g";
export var xl = "_ga-7";
export var xs = "_ga-3";
export var xxl = "_ga-8";
export var xxs = "_ga-2";
export var yellow = "_ga-e";